import { FormikErrors } from 'formik'
import { defaultValidators } from '$utils/formValidators'

const validateCareInformation = careInformation => {
  if (!careInformation || careInformation.length === 0) {
    return '¿Ya está? Cuéntanos un poquito más :)'
  }
  if (careInformation.length <= 50) {
    return '¿Ya está? Cuéntanos un poquito más. Mínimo 50 caracteres, que no es nada :)'
  }
  if (careInformation.length > 400) {
    return 'Tu búsqueda tiene que tener como máximo 400 caracteres'
  }
  if (!careInformation) {
    return '¿Ya está? Cuéntanos un poquito más :)'
  }
  return undefined
}

export const validatePhoneNumber = (phoneNumber: string) => {
  if (!defaultValidators.required(phoneNumber)) {
    return 'Teléfono móvil obligatorio'
  }

  if (!defaultValidators.isValidPhoneNumber(phoneNumber)) {
    return 'El teléfono móvil no es válido: tiene que ser una combinación de números (puede incluir extensión internacional)'
  }

  if (!defaultValidators.phoneNumberHasValidLength(phoneNumber)) {
    return 'El telefono movil debe de tener entre 9 y 15 caracteres'
  }

  return undefined
}

const validateAddress = address => {
  if (!address) {
    return 'Indicanos una dirección dónde buscar cuidadores'
  }
  return undefined
}

const validateHoursPerWeek = hoursPerWeek => {
  if (!hoursPerWeek) {
    return 'Indicanos una hora'
  }
  return undefined
}

const validateCareType = careType => {
  if (!careType) {
    return 'Indicanos un tipo de cuidado'
  }
  return undefined
}

export const serviceInformationValidator = (formValues, address) => {
  let error
  let errors: FormikErrors<any> = {}

  error = validateCareInformation(formValues.careInformation)
  if (error) errors.careInformation = error
  error = validatePhoneNumber(formValues.phoneNumber)
  if (error) errors.phoneNumber = error
  error = validateHoursPerWeek(formValues.hoursPerWeek)
  if (error) errors.hoursPerWeek = error
  error = validateCareType(formValues.careType)
  if (error) errors.careType = error
  error = validateAddress(address)
  if (error) errors.address = error

  return errors
}



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/BroadcastForm/ServiceInformationStep/ServiceInformationStep.validators.ts